<template>
  <vx-card no-shadow>
    <vs-alert active="true">
      Gib an, an welche Adresse deine Bestellungen geschickt werden sollen.
    </vs-alert>

      <div class="vx-row mb-4 mt-4">
      <div class="vx-col w-full">
         <vs-input
          class="w-full"
          label-placeholder="Telefon"
          v-model="phone"
          name="phone"
        />
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-3/4">
        <vs-input
          class="w-full"
          label-placeholder="Straße"
          v-model="street"
          name="street"
        />
      </div>
      <div class="vx-col w-1/4">
        <vs-input
          class="w-full"
          label-placeholder="Hausnummer"
          v-model="streetNumber"
        />
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          class="w-full"
          label-placeholder="Postleitzahl"
          v-model="zipCode"
          name="postalCode"
        />
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Ort" v-model="city" />
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-textarea
          class="w-full mb-base"
          label="Nachricht an Verkäufer"
          v-model="deliveryInstructions"
        />
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="onAddAddress"
        >Speichern</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import axios from "../../axios";
import {mapGetters, mapActions } from "vuex";


export default {
  data() {
    return {
      phone: "",
      street: "",
      streetNumber: "",
      zipCode: "",
      city: "",
      country: "Deutschland",
      deliveryInstructions: ""
    };
  },
   computed: {
    ...mapGetters({
      address: "auth/address",
    }),
  },
  mounted() {
    this.fetchAddress().then(res => {
      this.phone = res.data.address[0].phone;
      this.street = res.data.address[0].street;
      this.streetNumber = res.data.address[0].streetNumber;
      this.zipCode = res.data.address[0].zipCode;
      this.city = res.data.address[0].city;
      this.deliveryInstructions = res.data.address[0].deliveryInstructions;
    });
  },
  methods: {
     ...mapActions({
      fetchAddress: "auth/fetchAddress",
    }),
    async onAddAddress() {
      try {
        let data = {
          phone: this.phone,
          street: this.street,
          streetNumber: this.streetNumber,
          zipCode: this.zipCode,
          city: this.city,
          country: this.country,
          deliveryInstructions: this.deliveryInstructions
        };
        let response = await axios.post(
          "/api/addresses",
          data
        );

        if (response.data.success) {
           this.$vs.notify({
            title: "Erfolg",
            text: "Deine Adresse wurde erfolgreich gespeichert",
            color: "success",
            position: "top-center",
            icon: "favorite",
          });
        } 
      } catch (error) {
        console.log(error);
         this.$vs.notify({
            title: "Fehler",
            text: "Deine Adresse konnte nicht aktualisiert werden",
            color: "danger",
            position: "top-center",
            icon: "error",
          });
      }
    }
  }
};
</script>
